import React from "react";
import { IoCheckmark } from "react-icons/io5";
import { PlanFeature } from "./plan-feature";

export function PlanCard({ plan, selected, onSelect }) {
  return (
    <div
      onClick={() => onSelect(plan.id)}
      className="relative w-full cursor-pointer rounded-[16px] border border-solid bg-white px-5 py-5 text-left transition-all duration-300 hover:-translate-y-0.5 hover:shadow-[0_18px_45px_rgba(15,23,42,0.08)]"
      style={{
        borderColor: selected ? plan.accent : "#E5E5EF",
        boxShadow: selected ? `0 0 0 1px ${plan.accent} inset` : undefined,
        background: selected
          ? "linear-gradient(180deg,#fffdf6 0%,#ffffff 100%)"
          : "#fff",
      }}
    >
      {plan.recommended ? (
        <span className="absolute right-5 top-0 -translate-y-1/2 rounded-full bg-[#3A7BFF] px-3 py-1 text-[11px] font-bold uppercase tracking-wide text-white">
          Recommended
        </span>
      ) : null}

      <div className="flex items-start gap-4">
        <div
          className="grid h-12 w-12 shrink-0 place-items-center rounded-[14px] text-[22px]"
          style={{ backgroundColor: plan.iconBg }}
        >
          {plan.icon}
        </div>

        <div className="min-w-0 flex-1 pr-10">
          <p className="my-0 text-[16px] font-black text-[#18181B]">
            {plan.name}
          </p>
          <div className="mt-1 flex items-end gap-1">
            <span className="text-[24px] font-black leading-none text-[#111827]">
              {plan.price}
            </span>
            {plan.cadence ? (
              <span className="text-[14px] font-medium text-[#8A8CA0]">
                {plan.cadence}
              </span>
            ) : null}
          </div>

          <div className="mt-3 flex flex-wrap gap-2">
            {plan.features.map((feature) => (
              <PlanFeature key={feature}>{feature}</PlanFeature>
            ))}
          </div>
        </div>

        <span
          className={`absolute right-5 top-5 grid h-6 w-6 place-items-center rounded-full border transition-colors ${
            selected
              ? "border-transparent text-white"
              : "border-[#C8CBDD] text-transparent"
          }`}
          style={{ backgroundColor: selected ? plan.accent : "#fff" }}
        >
          <IoCheckmark className="text-[18px]" />
        </span>
      </div>
    </div>
  );
}
